import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import CheckoutStepDeliverables from '@/b2b/checkout/ui/CheckoutStepDeliverables.vue';
import { useCheckout } from '@/b2b/checkout/useCheckout';
import CheckoutPaymentReady from '@/b2b/checkout/ui/payment/CheckoutPaymentReady.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutSteps',
  setup(__props) {

const { basket } = useCheckout();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ol", null, [
    (_unref(basket).deliverables.length)
      ? (_openBlock(), _createBlock(CheckoutStepDeliverables, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(CheckoutPaymentReady)
  ]))
}
}

})